import { Component, Input } from "@angular/core";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";
import { externalIdToCode, CarrierCode } from "../../helpers/constants/transporters";

@Component({
    selector: "app-external-icon",
    templateUrl: "./external-icon.component.html",
    styleUrls: ["./external-icon.component.css"],
})
export class ExternalIconsComponent {
    @Input()
    external: string | number;

    constructor(private sanitizer: DomSanitizer) {}

    get externalUrl(): SafeStyle {
        const name: CarrierCode | "UNKNOWN" = externalIdToCode(this.external);

        return this.sanitizer.bypassSecurityTrustStyle(`url(assets/icons/${name}-icon.svg)`);
    }
}
